/** MeasurementPanelView.DEFAULT_COLORS (verbatim values) and PredictionObject colour fields. */

export type Rgba = [number, number, number, number];

export const DEFAULT_COLORS: Record<string, Rgba> = {
  // CENTERLINE / SEGMENTATIONS
  Centerline: [0, 1, 0, 0.5],
  AortaCurve: [0, 1, 1, 0.65],
  AorticRoot: [0, 1, 0, 0.1],
  LSinus: [1, 0, 0, 0.4],
  RSinus: [1.0, 0.922, 0.016, 0.4],
  NSinus: [0, 0, 1, 0.4],
  LVOT: [0, 0.6, 1, 0.4],
  AortaLvSegmentation: [0.2, 0.85, 0.55, 0.45],
  CoronariesSegmentation: [1, 0.55, 0.1, 0.4],
  LeftAtriumSegmentation: [0.55, 0.35, 0.9, 0.4],
  RightAtriumSegmentation: [0.25, 0.75, 0.95, 0.4],
  PulmonaryArterySegmentation: [0.1, 0.45, 0.85, 0.4],
  MidAscendingAortaSegmentation: [1, 0.35, 0.35, 0.4],
  DistalAscendingAortaSegmentation: [1, 0.7, 0.3, 0.4],
  MidTransverseArchSegmentation: [0.6, 0.85, 0.3, 0.4],
  MidDescendingAortaSegmentation: [0.7, 0.4, 0.2, 0.4],
  LeafletNSegmentation: [0.3, 0.6, 1, 0.85],
  LeafletRSegmentation: [1, 0.85, 0.2, 0.85],
  LeafletLSegmentation: [1, 0.35, 0.35, 0.85],
  LeafletNModelSegmentation: [0.6, 0.8, 1, 0.85],
  LeafletRModelSegmentation: [1, 0.93, 0.6, 0.85],
  LeafletLModelSegmentation: [1, 0.65, 0.65, 0.85],
  CalciumSegmentation: [0.96, 0.94, 0.9, 1],
  VbrSegmentation: [0.18, 0.85, 0.78, 0.4],
  SovSegmentation: [0.97, 0.29, 0.64, 0.4],
  StjSegmentation: [0.75, 0.51, 0.99, 0.4],
  OstiaSegmentation: [0.7, 0.35, 0.1, 0.4],
  CommissuresSegmentation: [1, 0, 0.8, 0.4],
  CoaptationSegmentation: [1, 0.5, 0.9, 0.4],
  CoaptationDeficiencySegmentation: [0.85, 0.25, 0.95, 0.55],
  NGeometricHeight: [0.7, 0.75, 1.0, 1.0],
  RGeometricHeight: [1.0, 0.94, 0.7, 1.0],
  LGeometricHeight: [1.0, 0.62, 0.62, 1.0],
  RnLnFreeMargin: [0.2, 0.35, 1.0, 1],
  RnRlFreeMargin: [1.0, 1.0, 0.25, 1],
  RlLnFreeMargin: [1.0, 0.25, 0.25, 1],
  // NADIRS
  LNadir: [1.0, 0.25, 0.25, 1.0],
  RNadir: [1.0, 1.0, 0.25, 1.0],
  NNadir: [0.2, 0.35, 1.0, 1.0],
  // VIRTUAL BASAL RING
  VbrPlane: [1, 0.55, 0, 1],
  VbrEllipse: [1, 0.55, 0, 1],
  VbrArea: [1, 0.55, 0, 1],
  VbrMaxDiameter: [1, 0.55, 0, 1],
  VbrMinDiameter: [1, 0.55, 0, 1],
  // SINUS OF VALSALVA
  SovContour: [0.97, 0.29, 0.64, 1],
  SovArea: [0.97, 0.29, 0.64, 1],
  SovMaxDiameter: [0.97, 0.29, 0.64, 1],
  SovMinDiameter: [0.97, 0.29, 0.64, 1],
  SovHeight: [0.97, 0.29, 0.64, 1],
  // SINOTUBULAR JUNCTION
  StjContour: [0.75, 0.51, 0.99, 1],
  StjArea: [0.75, 0.51, 0.99, 1],
  StjMaxDiameter: [0.75, 0.51, 0.99, 1],
  StjMinDiameter: [0.75, 0.51, 0.99, 1],
  StjHeight: [0.75, 0.51, 0.99, 1],
  // ASCENDING AORTA
  AscAortaContour: [0.18, 0.8, 0.75, 1],
  AscAortaMaxDiameter: [0.18, 0.8, 0.75, 1],
  AscAortaMinDiameter: [0.18, 0.8, 0.75, 1],
  AscAortaHeight: [0.18, 0.8, 0.75, 1],
  // CORONARY OSTIA
  LcaCoronaryOstia: [0.6, 0.1, 0.1, 1],
  RcaCoronaryOstia: [0.8, 0.6, 0, 1],
  LcaHeight: [0.6, 0.1, 0.1, 1],
  RcaHeight: [0.8, 0.6, 0, 1],
  // COMMISSURES AND ANGLES
  RlCommissure: [1, 0, 0.8, 1],
  RnCommissure: [1, 0, 0.8, 1],
  LnCommissure: [1, 0, 0.8, 1],
  RlHeight: [1, 0.5, 0.9, 1],
  RnHeight: [1, 0.5, 0.9, 1],
  LnHeight: [1, 0.5, 0.9, 1],
  RlRnLength: [0.75, 0.05, 0.45, 1],
  RlLnLength: [0.75, 0.05, 0.45, 1],
  RnLnLength: [0.75, 0.05, 0.45, 1],
  CentralCoaptationPoint: [1, 0, 0.8, 1],
  EffectiveHeight: [1, 0.5, 0.9, 1],
  CommissuralAnglePoint: [0.65, 0.35, 0.9, 1],
  RAngle: [1.0, 0.94, 0.7, 1.0],
  LAngle: [1.0, 0.62, 0.62, 1.0],
  NAngle: [0.7, 0.75, 1.0, 1.0],
};

/** PredictionObject colour fields used for 3D objects before the inventory row colour lands. */
export const PREDICTION_COLORS = {
  vbrRing: [1, 0.55, 0, 1] as Rgba,
  sovRing: [1, 0.15, 0.15, 1] as Rgba,
  stjRing: [0.65, 0.35, 0.9, 1] as Rgba,
  ascAortaRing: [0.18, 0.8, 0.75, 1] as Rgba,
  coaptation: [1, 0, 0.8, 0] as Rgba,
  projectedLine: [1, 0.5, 0.9, 1] as Rgba,
  centralLine: [0.65, 0.35, 0.9, 1] as Rgba,
  referenceLine: [1, 0, 0.8, 1] as Rgba,
  diameterDefault: [0.99, 0.47, 0.66, 1] as Rgba,
};

export const FREE_MARGIN_COLORS = {
  NSinusMargin: [0.2, 0.35, 1.0, 1] as Rgba,
  RSinusMargin: [1.0, 1.0, 0.25, 1] as Rgba,
  LSinusMargin: [1.0, 0.25, 0.25, 1] as Rgba,
  FusedRlMargin: [1.0, 0.55, 0.0, 1] as Rgba,
  FusedNrMargin: [0.2, 0.8, 0.3, 1] as Rgba,
  FusedNlMargin: [0.6, 0.3, 0.95, 1] as Rgba,
  Fallback: [0.75, 0.75, 0.75, 1] as Rgba,
};

export function rgbaToCss(c: Rgba): string {
  return `rgba(${Math.round(c[0] * 255)}, ${Math.round(c[1] * 255)}, ${Math.round(c[2] * 255)}, ${c[3]})`;
}

export function rgbaToHex(c: Rgba): string {
  const h = (v: number) => Math.round(Math.min(1, Math.max(0, v)) * 255).toString(16).padStart(2, '0');
  return `#${h(c[0])}${h(c[1])}${h(c[2])}`;
}

export function hexToRgba(hex: string, alpha: number): Rgba {
  const n = parseInt(hex.replace('#', ''), 16);
  return [((n >> 16) & 255) / 255, ((n >> 8) & 255) / 255, (n & 255) / 255, alpha];
}
